import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import newLogo from "../images/newLogo.png";
import { UserContext } from "../Context/UserContext";
import "../styleSheets/home.css";

function Navbar() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, [userDetails]);

  const onLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/login");
  };

  // ✅ Close sidebar properly
  const closeSidebar = () => {
    const offcanvasElement = document.getElementById("mobileSidebar");

    if (!offcanvasElement) return;

    const bsOffcanvas =
      window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement);

    bsOffcanvas.hide();
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <>
      {/* ================= NAVBAR ================= */}
      <nav className="navbar navbar-dark bg-dark navbar-expand-lg">
        <div className="container-fluid">
          {/* Left Section: Hamburger + Logo + Text */}
          <div className="d-flex align-items-center">
            {/* Hamburger */}
            <button
              className="navbar-toggler me-2"
              type="button"
              onClick={() => setIsSidebarOpen(true)}
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Logo + Text */}
            <Link className="navbar-brand d-flex align-items-center m-0" to="/">
              <img className="myLogo me-2" src={newLogo} alt="logo" />
              <span className="fw-bold split">Split</span>
              <span className="fw-bold bites">Bites</span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="d-none d-lg-flex align-items-center w-100">
            <ul className="navbar-nav me-auto ms-2">
              <li className="nav-item mx-2">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item mx-2">
                <Link className="nav-link" to="/addTransaction">
                  Add Transaction
                </Link>
              </li>

              <li className="nav-item mx-2">
                <Link className="nav-link" to="/emi">
                  EMI Tracker
                </Link>
              </li>

              <li className="nav-item mx-2">
                <Link className="nav-link" to="/foodiesNetwork">
                  Foodies Network
                </Link>
              </li>

              <li className="nav-item mx-2">
                <Link className="nav-link" to="/MoneyFlow">
                  MoneyFlow
                </Link>
              </li>

              {userDetails.role === "ADMIN" && (
                <li className="nav-item">
                  <Link className="nav-link mx-2" to="/swiggyTracker">
                    Swiggy Tracker
                  </Link>
                </li>
              )}

              <li className="nav-item">
                <Link className="nav-link mx-2" to="/settings">
                  Settings
                </Link>
              </li>
            </ul>

            {isLoggedIn && (
              <div className="d-flex align-items-center">
                <Link to="/UserProfile">
                  <img
                    className="prof me-3"
                    src={
                      userDetails?.profilePicture?.url ||
                      "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg"
                    }
                    alt="profile"
                  />
                </Link>

                <button className="btn navbar-btn" onClick={onLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* ================= MOBILE SIDEBAR ================= */}
      {/* Custom Sidebar */}
      <div className={`custom-sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-inner">
          <button
            className="btn-close btn-close-white mb-4"
            onClick={() => setIsSidebarOpen(false)}
          ></button>

          <ul className="sidebar-menu ">
            <>
              <li>
                <Link
                  className="nav-link"
                  to="/"
                  onClick={() => setIsSidebarOpen(false)}
                >
                  <i class="bi bi-house-door-fill mx-1"></i> Home
                </Link>
              </li>

              <li>
                <Link
                  className="nav-link"
                  to="/addTransaction"
                  onClick={() => setIsSidebarOpen(false)}
                >
                  <i class="bi bi-plus-circle mx-1"></i> Add Transaction
                </Link>
              </li>

              <li>
                <Link
                  className="nav-link"
                  to="/emi"
                  onClick={() => setIsSidebarOpen(false)}
                >
                  <i class="bi bi-credit-card mx-1"></i> EMI Tracker
                </Link>
              </li>

              <li>
                <Link
                  className="nav-link"
                  to="/foodiesNetwork"
                  onClick={() => setIsSidebarOpen(false)}
                >
                  <i class="bi bi-globe mx-1"></i> Foodies Network
                </Link>
              </li>

              <li>
                <Link
                  className="nav-link"
                  to="/MoneyFlow"
                  onClick={() => setIsSidebarOpen(false)}
                >
                  <i class="bi bi-currency-rupee mx-1"></i> Money Flow
                </Link>
              </li>

              {userDetails.role === "ADMIN" && (
                <li>
                  <Link
                    className="nav-link"
                    to="/swiggyTracker"
                    onClick={() => setIsSidebarOpen(false)}
                  >
                    <i class="fa-solid fa-bars-progress mx-1"></i> Swiggy
                    Tracker
                  </Link>
                </li>
              )}

              <li>
                <Link
                  className="nav-link"
                  to="/settings"
                  onClick={() => setIsSidebarOpen(false)}
                >
                  <i class="bi bi-gear mx-1"></i> Settings
                </Link>
              </li>
            </>
          </ul>

          {isLoggedIn && (
            <div className="sidebar-bottom">
              <li>
                <Link
                  className="nav-link"
                  to="/UserProfile"
                  onClick={() => setIsSidebarOpen(false)}
                >
                  <img
                    className="prof"
                    src={
                      userDetails?.profilePicture?.url ||
                      "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg"
                    }
                  />
                  <span className="fs-2 mx-1">{userDetails.name}</span>
                </Link>
              </li>

              <li>
                <button
                  className="btn btn-danger mt-3 w-100"
                  onClick={() => {
                    setIsSidebarOpen(false);
                    onLogout();
                  }}
                >
                  Logout
                </button>
              </li>
            </div>
          )}
        </div>
      </div>

      {/* Overlay */}
      {isSidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Navbar;
